import { useMutation, useQueryClient } from "@tanstack/react-query";
import createPhaseRule from "api/campaign/createPhaseRule";
import handleInvalidateError from "helpers/handleInvalidateError";
import { phaseIdKey } from "queryKeys/phase";
import { phaseRulesWithCampaignId } from "queryKeys/phaseRulesKey";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export default function useCreatePhaseRuleMutation() {
  const queryClient = useQueryClient();
  const { id: campaignId } = useParams();

  return useMutation({
    mutationFn: createPhaseRule,
    onSuccess: (data) => {
      toast.success(data.message || "Rule created successfully.");

      queryClient
        .invalidateQueries({ queryKey: phaseRulesWithCampaignId({ campaignId }) })
        .catch(handleInvalidateError);
      queryClient
        .invalidateQueries({ queryKey: phaseIdKey(campaignId) })
        .catch(handleInvalidateError);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
}
